import React, { useState } from 'react'
import { sortBy } from 'lodash'
import PropTypes from 'prop-types'
import TextField from '@mui/material/TextField'

import useIndustrySearch, { IndustryType } from '@/modules/onboardingV2/components/search/useIndustrySearch'
import { useStyles, StyledAutocomplete, useNewStyles } from '@/modules/onboardingV2/components/search/search.styles'
import shortId from '@/utils/short-id'
import lang from '@/lang'

interface SearchProps {
  setInputsValid: (valid: boolean) => void
  onChange: () => void
  useFormTheme: boolean
}

const Search = (props: SearchProps) => {
  const { setInputsValid, onChange = null, useFormTheme = false } = props
  const { industries, value, handleChange } = useIndustrySearch({ setInputsValid, onChange })
  const [searchTerm, setSearchTerm] = useState('')
  const classes = useFormTheme ? useNewStyles() : useStyles()
  const elementId = `input-groupedIndustries-${shortId()}`

  return (
    <div className={classes.wrapper}>
      { useFormTheme && <label htmlFor={elementId} className={classes.label}>{lang.onboarding.search.label}</label> }
      <StyledAutocomplete
        id={elementId}
        options={sortBy(industries, ['labelGroup', 'label'])}
        groupBy={(industry: IndustryType) => industry.labelGroup}
        getOptionLabel={(industry: IndustryType) => industry.label}
        value={value || null}
        renderInput={params => (<TextField
          {...params}
          classes={{ root: classes.input }}
          variant="outlined"
          {...(useFormTheme ? { placeholder: lang.onboarding.search.placeholder } : { label: lang.onboarding.search.title })}
        />)}
        onChange={handleChange}
        onInputChange={(_, term) => setSearchTerm(term)}
        noOptionsText={lang.onboarding.search.searchTitle}
        open={Boolean(searchTerm.length) && !value}
        popupIcon={null}
      />
    </div>
  )
}

Search.propTypes = {
  setInputsValid: PropTypes.func,
}

Search.defaultProps = {
  setInputsValid: () => {},
}

export default Search
